<div
  *ngIf="!outlineStyle; else outlineStyleForm"
  [formGroup]="addressCtrl"
  fxLayout="row wrap"
  fxLayoutGap="5px"
>
  <mat-form-field fxFlex="100" class="prefix-label" [ngClass]="cssClass">
    <span matPrefix>Address</span>
    <input matInput class="e2e-address" formControlName="streetAddress" />
  </mat-form-field>
  <div fxFlex="100" fxLayout="row" fxLayoutGap="5px">
    <mat-form-field fxFlex="30" class="prefix-label" [ngClass]="cssClass">
      <span matPrefix>City</span>
      <input matInput class="e2e-city" formControlName="city" />
    </mat-form-field>
    <mat-form-field fxFlex="35" class="prefix-label" [ngClass]="cssClass">
      <span matPrefix>State/Region</span>
      <input matInput class="e2e-region" formControlName="region" />
    </mat-form-field>
    <mat-form-field fxFlex class="prefix-label" [ngClass]="cssClass">
      <span matPrefix>ZIP</span>
      <input matInput class="e2e-zip" formControlName="postalCode" />
    </mat-form-field>
  </div>
  <div fxLayout="row wrap" fxLayoutGap="5px">
    <mat-form-field fxFlex="35" class="prefix-label" [ngClass]="cssClass">
      <span matPrefix>County</span>
      <input matInput formControlName="county" />
    </mat-form-field>
    <mat-form-field fxFlex="40" class="prefix-label" [ngClass]="cssClass">
      <span matPrefix>Country</span>
      <input matInput formControlName="country" />
    </mat-form-field>
    <mat-form-field fxFlex="20" class="prefix-label" [ngClass]="cssClass">
      <span matPrefix>Gps Id</span>
      <input matInput formControlName="gpsId" />
    </mat-form-field>
    <div *ngIf="latLonConfirmed != null" class="lat-lon-status">
      <mat-icon *ngIf="latLonConfirmed === true" class="confirmed" title="Scene Location Confirmed"
        >check_circle</mat-icon
      >
      <mat-icon
        *ngIf="latLonConfirmed === false"
        class="unconfirmed"
        title="Scene Location Unconfirmed"
        >block</mat-icon
      >
    </div>
    <tcs-coordinates
      fxFlex="90"
      fxLayoutGap="10px"
      prefixLabel="true"
      [formGroup]="addressCtrl.get('coordinates')"
      required
      [cssClass]="cssClass"
    ></tcs-coordinates>
  </div>
</div>

<ng-template #outlineStyleForm>
  <div [formGroup]="addressCtrl" fxLayout="row wrap" class="outline-style-form">
    <mat-form-field appearance="outline" fxFlex="100" [ngClass]="cssClass">
      <mat-label>Address</mat-label>
      <input matInput class="e2e-address" formControlName="streetAddress" />
    </mat-form-field>
    <div fxFlex="100" fxLayout="row" fxLayoutGap="5px">
      <mat-form-field appearance="outline" fxFlex="30" [ngClass]="cssClass">
        <mat-label>City</mat-label>
        <input matInput class="e2e-city" formControlName="city" />
      </mat-form-field>
      <mat-form-field appearance="outline" fxFlex="35" [ngClass]="cssClass">
        <mat-label>State</mat-label>
        <input matInput class="e2e-region" formControlName="region" />
      </mat-form-field>
      <mat-form-field appearance="outline" fxFlex [ngClass]="cssClass">
        <mat-label>Zip</mat-label>
        <input matInput class="e2e-zip" formControlName="postalCode" />
      </mat-form-field>
    </div>
    <div fxFlex="100" fxLayout="row" fxLayoutGap="5px">
      <mat-form-field appearance="outline" fxFlex="40" [ngClass]="cssClass">
        <mat-label>County</mat-label>
        <input matInput formControlName="county" />
      </mat-form-field>
      <mat-form-field appearance="outline" fxFlex="30" [ngClass]="cssClass">
        <mat-label>Country</mat-label>
        <input matInput formControlName="country" />
      </mat-form-field>
      <mat-form-field appearance="outline" fxFlex [ngClass]="cssClass">
        <mat-label>Gps Id</mat-label>
        <input matInput formControlName="gpsId" />
      </mat-form-field>
    </div>
    <div fxFlex="100" fxLayout="row" fxLayoutGap="5px">
      <div *ngIf="latLonConfirmed != null" class="lat-lon-status outline-style">
        <mat-icon
          *ngIf="latLonConfirmed === true"
          class="confirmed"
          title="Scene Location Confirmed"
          >check_circle</mat-icon
        >
        <mat-icon
          *ngIf="latLonConfirmed === false"
          class="unconfirmed"
          title="Scene Location Unconfirmed"
          >block</mat-icon
        >
      </div>
      <tcs-coordinates
        fxFlex="100"
        fxLayoutGap="5px"
        prefixLabel="true"
        [formGroup]="addressCtrl.get('coordinates')"
        [outlineStyle]="outlineStyle"
        required
        [cssClass]="cssClass"
      ></tcs-coordinates>
    </div>
  </div>
</ng-template>
